import { useSetModal } from "@/shared/atoms/useModal";
import usePosOrderUser, {
  defaultPosOrderUser,
} from "@/shared/atoms/usePosOrderUser";
import { getUserAddress } from "@/shared/utils/helpers";
import Icon from "../Icon/Icon";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";

const PosCartOrderUser = () => {
  const [orderUser, setOrderUser] = usePosOrderUser();
  const setModal = useSetModal();
  const [deliveryMethod] = usePosOrderDeliveryMethod();

  const show =
    getUserAddress(orderUser ?? {}) || orderUser?.name || orderUser?.telephone;
  return show ? (
    <div className="flex h-auto flex-col gap-3 bg-white p-3 my-1 border border-border rounded-lg">
      <div className="flex justify-around rounded-lg border border-border p-2 text-2xl font-bold">
        <div className="flex items-center gap-2">
          <Icon className="h-8 w-8 fill-primary" variants="user_circle" />
          <span>{orderUser.name || ""}</span>
        </div>

        <div className="flex items-center gap-2">
          <Icon className="h-8 w-8 fill-primary" variants="phone" />
          <span>{orderUser.telephone || ""}</span>
        </div>
      </div>

      <div className="flex items-start gap-3 rounded-lg border border-border p-2 text-2xl font-bold">
        <Icon
          className="mt-1 h-12 w-12 shrink-0 fill-primary"
          variants="home"
        />

        <p className="flex-1 wrap-break-word leading-tight">
          {getUserAddress(orderUser)} {orderUser.city || ""}
        </p>
      </div>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={() =>
            setModal("orderUser", { deliveryMethodId: deliveryMethod })
          }
          className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-border py-3 transition hover:bg-primary/10"
        >
          <Icon className="h-12 w-12 fill-primary" variants="edit" />
        </button>

        <button
          type="button"
          onClick={() => setOrderUser(defaultPosOrderUser)}
          className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-border py-3 transition hover:bg-error/10"
        >
          <Icon className="h-12 w-12 fill-error" variants="trash" />
        </button>
      </div>
    </div>
  ) : null;
};
export default PosCartOrderUser;
